(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ps-cart-drawer')) return;
    const OPEN = '{' + '{'; const CLOSE = '}' + '}';
    const fallback = '$' + OPEN + 'amount' + CLOSE;
    const re = new RegExp(OPEN + '\\s*(\\w+)\\s*' + CLOSE);
    function money(cents, format) {
      const value = cents / 100;
      const m = re.exec(format || fallback); const key = m ? m[1] : 'amount';
      const num = (v, dec, thou, decSep) => { const p = v.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou); return p.length > 1 ? p.join(decSep) : p[0]; };
      let out;
      switch (key) {
        case 'amount_no_decimals': out = num(value, 0, ',', '.'); break;
        case 'amount_with_comma_separator': out = num(value, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = num(value, 0, '.', ','); break;
        case 'amount_with_space_separator': out = num(value, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': out = num(value, 0, ' ', ','); break;
        case 'amount_with_apostrophe_separator': out = num(value, 2, "'", '.'); break;
        default: out = num(value, 2, ',', '.');
      }
      return (format || fallback).replace(re, out);
    }

    class PsCartDrawer extends HTMLElement {
      connectedCallback() {
        this.format = this.dataset.moneyFormat;
        this.threshold = parseInt(this.dataset.threshold || '0', 10);
        this.autoOpen = this.dataset.autoOpen === 'true';
        this.fetchCompare = this.dataset.fetchCompare === 'true';
        this.root = this.dataset.localeRoot || '/';
        this.compareCache = {};
        this.panel = this.querySelector('.ps-cart__panel');
        this.itemsEl = this.querySelector('[data-pc-items]');
        this.tpl = this.querySelector('[data-pc-item-template]');
        this.cart = null;

        this.querySelectorAll('[data-pc-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this.querySelectorAll('.ps-cart__empty a, .ps-cart__trust a').forEach((a) => a.addEventListener('click', () => this.close()));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });

        /* open triggers */
        document.addEventListener('click', (e) => {
          const t = e.target.closest('[data-ps-cart], a[href="/cart"], a[href$="/cart"], [data-pc-open]');
          if (!t) return;
          if (t.dataset && t.dataset.cartAction === 'page') return;
          e.preventDefault(); e.stopPropagation();
          this.toggle();
        }, true);

        /* Horizon / standard cart events */
        document.addEventListener('shopify:cart:lines-update', (e) => {
          const act = (e.detail && e.detail.action) || e.action;
          const done = () => this.refresh().then(() => { if (act === 'add' && this.autoOpen) this.open(); });
          if (e.promise && e.promise.then) e.promise.then(done).catch(done); else setTimeout(done, 250);
        });
        document.addEventListener('ps:cart:refresh', () => this.refresh());

        /* upsell adds */
        this.querySelectorAll('[data-pc-add]').forEach((b) => b.addEventListener('click', () => this.add(b.dataset.pcAdd, b)));
        this.initUpsellSlider();

        /* note */
        const note = this.querySelector('[data-pc-note]'); const noteInput = this.querySelector('[data-pc-note-input]');
        if (note) note.addEventListener('change', () => { noteInput.value = note.value; fetch(this.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }); });

        /* expose */
        window.PS = Object.assign(window.PS || {}, { openCartDrawer: () => this.open(), toggleCartDrawer: () => this.toggle(), closeCartDrawer: () => this.close(), refreshCart: () => this.refresh() });
        this.refresh();
      }

      /* ---------- state ---------- */
      open() { if (this.classList.contains('is-open')) return; this.refresh(); this.classList.add('is-open'); document.body.classList.add('ps-cart-locked'); this.panel && this.panel.focus(); }
      close() { this.classList.remove('is-open'); document.body.classList.remove('ps-cart-locked'); }
      toggle() { this.classList.contains('is-open') ? this.close() : this.open(); }

      async refresh() {
        try {
          const r = await fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' } });
          this.cart = await r.json();
          await this.render();
          document.dispatchEvent(new CustomEvent('ps:cart:updated', { detail: { cart: this.cart } }));
        } catch (e) { console.warn('[ps-cart] refresh failed', e); }
      }
      async change(key, quantity, el) {
        el && el.classList.add('is-busy');
        try {
          const r = await fetch(this.root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
          this.cart = await r.json();
          await this.render();
          document.dispatchEvent(new CustomEvent('ps:cart:updated', { detail: { cart: this.cart } }));
        } catch (e) { console.warn('[ps-cart] change failed', e); el && el.classList.remove('is-busy'); }
      }
      async add(variantId, btn) {
        const orig = btn ? btn.textContent : '';
        btn && (btn.disabled = true);
        try {
          await fetch(this.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }) });
          await this.refresh();
          if (btn) { btn.textContent = this.dataset.addedLabel || 'Added'; setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1600); }
        } catch (e) { btn && (btn.disabled = false); }
      }
      async compareFor(item) {
        if (!this.fetchCompare || !item.handle) return 0;
        if (this.compareCache[item.variant_id] !== undefined) return this.compareCache[item.variant_id];
        try {
          const r = await fetch(this.root + 'products/' + item.handle + '.js');
          const p = await r.json();
          p.variants.forEach((v) => { this.compareCache[v.id] = v.compare_at_price || 0; });
        } catch (e) { this.compareCache[item.variant_id] = 0; }
        return this.compareCache[item.variant_id] || 0;
      }

      /* ---------- render ---------- */
      async render() {
        const c = this.cart; if (!c) return;
        const count = c.item_count;
        const countEl = this.querySelector('[data-pc-count]'); const countWrap = this.querySelector('[data-pc-count-wrap]');
        if (countEl) countEl.textContent = count; if (countWrap) countWrap.hidden = count === 0;
        document.querySelectorAll('.cart-bubble__text-count, [data-ps-cart-count]').forEach((el) => { el.textContent = count; el.classList.toggle('hidden', count === 0); });
        document.querySelectorAll('.cart-bubble').forEach((el) => el.classList.toggle('visually-hidden', count === 0));

        const empty = this.querySelector('[data-pc-empty]'); const foot = this.querySelector('[data-pc-foot]'); const ship = this.querySelector('[data-pc-ship]'); const upsell = this.querySelector('[data-pc-upsell]');
        if (empty) empty.hidden = count > 0; if (foot) foot.hidden = count === 0; if (ship) ship.hidden = count === 0;

        /* items */
        this.itemsEl.innerHTML = '';
        let savings = 0;
        for (const item of c.items) {
          const node = this.tpl.content.firstElementChild.cloneNode(true);
          node.dataset.key = item.key;
          node.querySelectorAll('[data-pc-item-url]').forEach((a) => (a.href = item.url));
          const img = node.querySelector('[data-pc-item-img]');
          if (item.image) { img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2'); img.alt = item.product_title; } else img.remove();
          node.querySelector('[data-pc-item-title]').textContent = item.product_title;
          const meta = [];
          if (item.variant_title && item.variant_title !== 'Default Title') meta.push(item.variant_title);
          if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) meta.push(item.selling_plan_allocation.selling_plan.name);
          (item.properties && Object.keys(item.properties).forEach((k) => { if (!k.startsWith('_') && item.properties[k]) meta.push(k + ': ' + item.properties[k]); }));
          node.querySelector('[data-pc-item-meta]').textContent = meta.join(' · ');
          const badge = node.querySelector('[data-pc-item-badge]');
          if (item.selling_plan_allocation) { badge.hidden = false; badge.textContent = 'Subscription'; }
          const priceEl = node.querySelector('[data-pc-item-price]');
          const cmpEl = node.querySelector('[data-pc-item-compare]');
          const saveEl = node.querySelector('[data-pc-item-save]');
          priceEl.textContent = money(item.final_line_price, this.format);
          const compareUnit = await this.compareFor(item);
          const original = Math.max(item.original_line_price, compareUnit * item.quantity);
          if (original > item.final_line_price) {
            cmpEl.hidden = false; cmpEl.textContent = money(original, this.format);
            saveEl.hidden = false; saveEl.textContent = 'Save ' + money(original - item.final_line_price, this.format);
            savings += original - item.final_line_price;
          }
          node.querySelector('[data-pc-qty-value]').textContent = item.quantity;
          node.querySelector('[data-pc-qty-minus]').addEventListener('click', () => this.change(item.key, item.quantity - 1, node));
          node.querySelector('[data-pc-qty-plus]').addEventListener('click', () => this.change(item.key, item.quantity + 1, node));
          node.querySelector('[data-pc-remove]').addEventListener('click', () => this.change(item.key, 0, node));
          this.itemsEl.appendChild(node);
        }
        /* hide upsell items already in cart */
        if (upsell) {
          const inCart = new Set(c.items.map((i) => String(i.product_id)));
          const cards = Array.from(upsell.querySelectorAll('[data-pc-upsell-item]'));
          let visible = 0;
          cards.forEach((card) => { const hide = inCart.has(card.dataset.productId); card.hidden = hide; if (!hide) visible++; });
          upsell.hidden = visible === 0 || count === 0 && this.dataset.upsellWhenEmpty !== 'true';
          this.layoutUpsell();
        }
        /* totals */
        const totalTxt = money(c.total_price, this.format);
        const totalEl = this.querySelector('[data-pc-total]'); if (totalEl) totalEl.textContent = totalTxt;
        const ckTotal = this.querySelector('[data-pc-checkout-total]'); if (ckTotal) ckTotal.textContent = totalTxt;
        const savRow = this.querySelector('[data-pc-savings-row]'); const savEl = this.querySelector('[data-pc-savings]');
        const totalSavings = savings + (c.total_discount || 0) - Math.min(savings, c.total_discount || 0);
        if (savRow) { savRow.hidden = totalSavings <= 0; if (savEl) savEl.textContent = '- ' + money(totalSavings, this.format); }
        /* shipping */
        if (ship && this.threshold > 0) {
          const remaining = this.threshold - c.total_price;
          const pct = Math.min(100, Math.round((c.total_price / this.threshold) * 100));
          const fill = this.querySelector('[data-pc-ship-fill]'); const icon = this.querySelector('[data-pc-ship-icon]'); const txt = this.querySelector('[data-pc-ship-text]');
          fill && fill.style.setProperty('--p', pct + '%'); icon && icon.style.setProperty('--p', pct + '%');
          ship.classList.toggle('ps-cart__ship--done', remaining <= 0);
          if (txt) txt.innerHTML = remaining <= 0 ? this.msg('unlocked') : this.msg('remaining').replace('[amount]', '<b>' + money(remaining, this.format) + '</b>');
        }
      }
      msg(k) { return this.getAttribute('data-msg-' + k) || (k === 'unlocked' ? 'Congrats! You have unlocked <b>FREE SHIPPING</b>' : 'You are [amount] away from free shipping'); }

      /* ---------- upsell slider ---------- */
      initUpsellSlider() {
        this.upTrack = this.querySelector('[data-pc-upsell-track]'); if (!this.upTrack) return;
        this.upIndex = 0;
        const prev = this.querySelector('[data-pc-upsell-prev]'), next = this.querySelector('[data-pc-upsell-next]');
        prev && prev.addEventListener('click', () => this.goUpsell(this.upIndex - 1));
        next && next.addEventListener('click', () => this.goUpsell(this.upIndex + 1));
        this.layoutUpsell();
      }
      layoutUpsell() {
        if (!this.upTrack) return;
        this.upCards = Array.from(this.upTrack.children).filter((c) => !c.hidden);
        const dots = this.querySelector('[data-pc-upsell-dots]');
        if (dots) { dots.innerHTML = ''; this.upCards.forEach((_, i) => { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to ' + (i + 1)); b.addEventListener('click', () => this.goUpsell(i)); dots.appendChild(b); }); }
        const nav = this.querySelector('.ps-cart__upsell-nav'); if (nav) nav.style.display = this.upCards.length > 1 ? '' : 'none';
        this.goUpsell(0);
      }
      goUpsell(i) {
        if (!this.upCards || !this.upCards.length) return;
        const n = this.upCards.length; this.upIndex = (i + n) % n;
        this.upTrack.style.transform = 'translateX(' + (-this.upIndex * 100) + '%)';
        /* hidden cards still take space? No: they're display:none via [hidden], so index maps to visible cards */
        const dots = this.querySelector('[data-pc-upsell-dots]');
        dots && Array.from(dots.children).forEach((d, k) => d.setAttribute('aria-current', k === this.upIndex ? 'true' : 'false'));
      }
    }
    customElements.define('ps-cart-drawer', PsCartDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ps-faq')) return;
    class PsFaq extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.ps-faq__tab'));
        this.thumb = this.querySelector('.ps-faq__tab-thumb');
        this.items = Array.from(this.querySelectorAll('.ps-faq__item'));
        this.tabs.forEach((t) => t.addEventListener('click', () => this.select(t)));
        window.addEventListener('resize', () => this.moveThumb());
        requestAnimationFrame(() => this.moveThumb(true));
        /* close others for a calmer feel */
        this.items.forEach((d) => d.addEventListener('toggle', () => {
          if (d.open) this.items.forEach((o) => { if (o !== d && o.open) o.open = false; });
        }));
      }
      select(tab) {
        this.tabs.forEach((t) => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
        const cat = tab.dataset.cat;
        this.items.forEach((d, i) => {
          const show = d.dataset.cat === cat;
          d.hidden = !show;
          if (show) { d.style.animation = 'none'; void d.offsetWidth; d.style.animation = ''; d.style.animationDelay = (i % 8) * 40 + 'ms'; }
        });
        this.moveThumb();
      }
      moveThumb(init) {
        if (!this.thumb) return;
        const active = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
        if (!active) return;
        const pr = this.thumb.parentElement.getBoundingClientRect();
        const r = active.getBoundingClientRect();
        this.thumb.style.width = r.width + 'px';
        this.thumb.style.transform = 'translate(' + (r.left - pr.left) + 'px,' + (r.top - pr.top - 4) + 'px)';
        if (init) this.thumb.classList.add('is-ready');
      }
    }
    customElements.define('ps-faq', PsFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ps-header')) return;
    class PsHeader extends HTMLElement {
      connectedCallback() {
        this.sticky = this.dataset.sticky;
        this.threshold = parseInt(this.dataset.threshold || '12', 10);
        this.announce = this.querySelector('.ps-announce');
        this.drawer = this.querySelector('[data-ps-drawer]');
        this.burger = this.querySelector('[data-ps-menu-open]');
        this.lastY = window.scrollY;
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        /* primary: sentinel observer (works in any scroll container, editor iframe included) */
        this.sentinel = this.querySelector('[data-ps-sentinel]');
        if (this.sentinel && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver((en) => {
            /* sentinel is threshold px tall and sits above the bar: scrolled once it has fully left the top */
            this.classList.toggle('is-scrolled', !en[0].isIntersecting && en[0].boundingClientRect.bottom <= 0);
          }, { threshold: 0 });
          this.io.observe(this.sentinel);
        }
        this.onScroll();

        this.querySelectorAll('[data-ps-cart]').forEach((b) => b.addEventListener('click', (e) => {
          e.preventDefault();
          if (b.dataset.cartAction !== 'drawer') { window.location.href = '/cart'; return; }
          if (window.PS && typeof window.PS.toggleCartDrawer === 'function') { window.PS.toggleCartDrawer(); return; }
          const d = document.getElementById('cart-drawer');
          if (d && typeof d.toggle === 'function') d.toggle();
          else if (d && d.querySelector('dialog')) { const dlg = d.querySelector('dialog'); dlg.open ? dlg.close() : dlg.showModal(); }
          else window.location.href = '/cart';
        }));

        this.burger && this.burger.addEventListener('click', () => this.openMenu());
        this.querySelectorAll('[data-ps-menu-close]').forEach((b) => b.addEventListener('click', () => this.closeMenu()));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeMenu(); });
        window.addEventListener('resize', () => { if (window.innerWidth > 989) this.closeMenu(); });
      }
      disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); this.io && this.io.disconnect(); }
      onScroll() {
        const y = window.scrollY;
        const stickyAnnounce = this.announce && this.announce.classList.contains('ps-announce--sticky');
        const base = this.announce && !stickyAnnounce ? this.announce.offsetHeight : 0;
        const threshold = base + this.threshold;
        if (!this.io) this.classList.toggle('is-scrolled', y > threshold);
        if (this.sticky === 'scroll-up') {
          const goingDown = y > this.lastY + 4;
          const goingUp = y < this.lastY - 4;
          if (y > threshold + 240 && goingDown) this.classList.add('is-hidden');
          else if (goingUp || y <= threshold) this.classList.remove('is-hidden');
        }
        this.lastY = y;
      }
      openMenu() {
        if (!this.drawer) return;
        this.drawer.classList.add('is-open');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.classList.add('is-menu-open');
        this.burger && this.burger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('ps-menu-locked');
      }
      closeMenu() {
        if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
        this.drawer.classList.remove('is-open');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.classList.remove('is-menu-open');
        this.burger && this.burger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('ps-menu-locked');
      }
    }
    customElements.define('ps-header', PsHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ps-steps')) return;
    class PsSteps extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-ps-step]'));
        this.imgs = Array.from(this.querySelectorAll('[data-ps-step-img]'));
        this.dots = Array.from(this.querySelectorAll('[data-ps-progress-dot]'));
        this.captions = Array.from(this.querySelectorAll('[data-ps-caption]'));
        if (!this.steps.length) return;
        this.mode = this.dataset.mode || 'scroll';
        this.interval = parseInt(this.dataset.interval || '4500', 10);
        this.focus = (parseInt(this.dataset.focus || '45', 10)) / 100;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.active = -1;
        this.locked = 0;

        this.steps.forEach((st, i) => {
          st.addEventListener('click', () => { this.set(i); this.locked = Date.now() + 2500; this.restart(); });
          st.addEventListener('mouseenter', () => { if (this.mode === 'hover') this.set(i); });
          st.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.set(i); this.locked = Date.now() + 2500; } });
        });

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);

        /* auto-cycle only while the section is on screen */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((en) => { this.inView = en[0].isIntersecting; if (this.inView) this.restart(); else clearInterval(this.timer); }, { threshold: 0.25 }).observe(this);
        }
        this.set(0);
        this.onScroll();
      }
      disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); clearInterval(this.timer); }
      restart() {
        clearInterval(this.timer);
        if (this.mode !== 'auto' || this.reduce) return;
        this.timer = setInterval(() => { if (this.inView && Date.now() > this.locked) this.set((this.active + 1) % this.steps.length); }, this.interval);
      }
      onScroll() {
        const focusY = window.innerHeight * this.focus;
        /* rail fill always follows scroll */
        const mobile = window.innerWidth < 990;
        this.steps.forEach((step, i) => {
          const r = step.getBoundingClientRect();
          const line = step.querySelector('.ps-how__line span');
          if (!line) return;
          if (mobile) {
            /* mobile: fill the whole rail as soon as the next step's dot is reached, eased by CSS */
            line.style.setProperty('--fill', r.top + r.height * 0.6 <= focusY ? '1' : '0');
          } else {
            line.style.setProperty('--fill', Math.min(1, Math.max(0, (focusY - r.top) / (r.height || 1))).toFixed(3));
          }
        });
        if (this.mode !== 'scroll' || Date.now() < this.locked) return;
        /* map scroll progress through the steps column onto step index, so short sections still change */
        const first = this.steps[0].getBoundingClientRect();
        const last = this.steps[this.steps.length - 1].getBoundingClientRect();
        const top = first.top;
        const bottom = last.bottom;
        const span = Math.max(1, bottom - top);
        let idx;
        if (span < window.innerHeight * 0.9) {
          /* whole list fits on screen: progress based on how far the list has travelled through the viewport */
          const p = (window.innerHeight * 0.75 - top) / (span + window.innerHeight * 0.35);
          idx = Math.floor(Math.min(0.999, Math.max(0, p)) * this.steps.length);
        } else {
          idx = 0;
          this.steps.forEach((s, i) => { if (s.getBoundingClientRect().top <= focusY) idx = i; });
        }
        this.set(idx);
      }
      set(i) {
        if (i === this.active) return;
        this.active = i;
        this.steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
        this.imgs.forEach((img) => img.classList.toggle('is-active', parseInt(img.dataset.psStepImg, 10) === i));
        this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        this.captions.forEach((c, k) => { c.hidden = k !== i; });
      }
    }
    customElements.define('ps-steps', PsSteps);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-ingredient-orbit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.poInit === '1') return;
      root.dataset.poInit = '1';
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var orbit = root.querySelector('[data-po-orbit]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-po-item]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-po-panel]'));
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-po-tab]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-po-dot]'));
      var n = items.length;
      if (!orbit || !n) return;

      var speed = reduce ? 0 : parseFloat(root.dataset.speed || '0');
      var autoplay = root.dataset.autoplay === 'true' && !reduce;
      var interval = parseInt(root.dataset.interval || '6000', 10);
      var hoverPause = root.dataset.hoverPause === 'true';
      var hoverSelect = root.dataset.hoverSelect === 'true';
      root.style.setProperty('--po-interval', interval + 'ms');

      var offset = -90, lastT = null, paused = false, current = 0, timer = null;

      function layout() {
        var w = orbit.clientWidth;
        var size = items[0].offsetWidth;
        var radius = w / 2 - size / 2 - 4;
        var c = w / 2 - size / 2;
        for (var i = 0; i < n; i++) {
          var a = (offset + (360 / n) * i) * Math.PI / 180;
          items[i].style.transform = 'translate(' + (c + radius * Math.cos(a)) + 'px,' + (c + radius * Math.sin(a)) + 'px)';
        }
      }
      function tick(t) {
        if (lastT === null) lastT = t;
        var dt = (t - lastT) / 1000; lastT = t;
        if (speed > 0 && !paused) { offset = (offset + speed * dt) % 360; layout(); }
        requestAnimationFrame(tick);
      }
      function select(i, user) {
        current = (i + n) % n;
        items.forEach(function (el, k) { el.classList.toggle('is-active', k === current); });
        panels.forEach(function (el, k) { el.classList.toggle('is-active', k === current); });
        tabs.forEach(function (el, k) { el.classList.toggle('is-active', k === current); el.setAttribute('aria-selected', k === current ? 'true' : 'false'); });
        dots.forEach(function (el, k) {
          el.classList.toggle('is-active', k === current);
          var bar = el.querySelector('i');
          if (bar && k === current) { bar.style.transition = 'none'; bar.style.transform = 'scaleX(0)'; void bar.offsetWidth; bar.style.transition = ''; bar.style.transform = ''; }
        });
        if (user) restart();
      }
      function restart() {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(function () { if (!paused) select(current + 1); }, interval);
      }

      items.forEach(function (item, i) {
        item.addEventListener('click', function () { select(i, true); });
        if (hoverSelect) item.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') select(i, true); });
      });
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { select(i, true); }); });
      var prev = root.querySelector('[data-po-prev]'), next = root.querySelector('[data-po-next]');
      prev && prev.addEventListener('click', function () { select(current - 1, true); });
      next && next.addEventListener('click', function () { select(current + 1, true); });
      if (hoverPause) {
        root.addEventListener('pointerenter', function () { paused = true; });
        root.addEventListener('pointerleave', function () { paused = false; });
      }
      window.addEventListener('resize', layout);
      layout();
      requestAnimationFrame(tick);
      restart();
    }
    function boot() { document.querySelectorAll('.ps-orbit').forEach(init); }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.ps-orbit'); if (r) init(r); });
    document.addEventListener('shopify:block:select', function (e) {
      var r = e.target.closest('.ps-orbit'); if (!r) return;
      var idx = Array.prototype.indexOf.call(r.querySelectorAll('[data-po-item]'), e.target);
      var item = r.querySelectorAll('[data-po-item]')[idx]; item && item.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-ps-more]');
      if (!btn) return;
      const desc = btn.previousElementSibling;
      const open = desc.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      const label = btn.querySelector('[data-more-label]');
      if (label) {
        if (!label.dataset.orig) label.dataset.orig = label.textContent;
        label.textContent = open ? 'Read less' : label.dataset.orig;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
